/**
 * analytics.js — iter196. Fire-and-forget event logging.
 *
 * Wraps POST /api/analytics/event so callers don't need to await or handle
 * errors. We never let a failed analytics call surface in the UI.
 *
 * Server-side ALLOWED_EVENT_TYPES whitelist enforces correctness — callers
 * just pass a string + optional source/metadata.
 */
import api from './api';

function detectDeviceClass() {
  try {
    const ua = navigator.userAgent || '';
    if (/iPad|Tablet/i.test(ua)) return 'tablet';
    if (/iPhone|Android|Mobile|Windows Phone/i.test(ua)) return 'mobile';
    if (/Macintosh|Windows|Linux|X11/i.test(ua)) return 'desktop';
  } catch { /* ignore */ }
  return 'unknown';
}

export async function logEvent(type, { source, metadata } = {}) {
  if (!type) return;
  try {
    const body = { type };
    if (source) body.source = source;
    if (metadata && Object.keys(metadata).length) body.metadata = metadata;
    body.device_class = detectDeviceClass();
    // Fire-and-forget; we ignore both the response and any error.
    await api.post('/analytics/event', body);
  } catch {
    // Silently swallow — analytics MUST NOT degrade UX.
  }
}

// Convenience wrappers — give the call sites readable, declarative names.
export const trackPasskeyPromptShown = () => logEvent('passkey_prompt_shown');
export const trackPasskeyPromptDismissed = () => logEvent('passkey_prompt_dismissed');
export const trackPasskeyEnrolled = (source) => logEvent('passkey_enrolled', { source });
export const trackPasskeyDeleted = () => logEvent('passkey_deleted');

export const trackPwaPromptShown = () => logEvent('pwa_install_prompt_shown');
export const trackPwaPromptDismissed = () => logEvent('pwa_install_prompt_dismissed');
export const trackPwaInstalled = () => logEvent('pwa_installed');
export const trackPwaIosDismissed = () => logEvent('pwa_install_ios_dismissed');
